import { render, staticRenderFns } from "./DuplicatePromotionModal.vue?vue&type=template&id=a4fdc35e&scoped=true&"
import script from "./DuplicatePromotionModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatePromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePromotionModal.vue?vue&type=style&index=0&id=a4fdc35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fdc35e",
  null
  
)

component.options.__file = "DuplicatePromotionModal.vue"
export default component.exports